import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Services.css';

const SparklesIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#E8B84B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2l2.4 5.6L20 10l-5.6 2.4L12 18l-2.4-5.6L4 10l5.6-2.4z"></path>
    <path d="M20 16l1.2 2.8L24 20l-2.8 1.2L20 24l-1.2-2.8L16 20l2.8-1.2z"></path>
  </svg>
);

// --- Decorative Corner SVG ---
const GoldCurvedCorner = () => (
  <svg width="240" height="240" viewBox="0 0 240 240" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M10 230 Q10 10 230 10" stroke="url(#cornerGrad)" strokeWidth="1.5" fill="none" strokeDasharray="6 5" strokeLinecap="round" />
    <path d="M30 230 Q30 30 230 30" stroke="url(#cornerGrad2)" strokeWidth="0.8" fill="none" strokeDasharray="4 8" strokeLinecap="round" opacity="0.6" />
    <path d="M55 230 Q55 55 230 55" stroke="url(#cornerGrad3)" strokeWidth="0.5" fill="none" strokeDasharray="3 10" strokeLinecap="round" opacity="0.35" />
    <defs>
      <linearGradient id="cornerGrad" x1="10" y1="230" x2="230" y2="10" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#E8B84B" stopOpacity="0.9" />
        <stop offset="100%" stopColor="#C89238" stopOpacity="0.1" />
      </linearGradient>
      <linearGradient id="cornerGrad2" x1="30" y1="230" x2="230" y2="30" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#D4A04A" stopOpacity="0.7" />
        <stop offset="100%" stopColor="#C89238" stopOpacity="0.05" />
      </linearGradient>
      <linearGradient id="cornerGrad3" x1="55" y1="230" x2="230" y2="55" gradientUnits="userSpaceOnUse">
        <stop offset="0%" stopColor="#C89238" stopOpacity="0.5" />
        <stop offset="100%" stopColor="#C89238" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

// --- Icons ---
const StarIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="#C98E32" stroke="none">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
  </svg>
);

const GoldCheckIcon = () => (
  <svg width="15" height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="8" cy="8" r="7" stroke="#D49B35" strokeWidth="1.2" fill="#FAF3E6" />
    <path d="M5 8.2L7 10.2L11 5.8" stroke="#B88228" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const PlusIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="12" y1="5" x2="12" y2="19"></line>
    <line x1="5" y1="12" x2="19" y2="12"></line>
  </svg>
);

const ChevronDownIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="6 9 12 15 18 9"></polyline>
  </svg>
);

const ChevronUpIcon = () => (
  <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
);

const ShieldCheckIcon = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="M9 12l2 2 4-4"></path>
  </svg>
);

const GoldShieldIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
    <path d="M9 12l2 2 4-4"></path>
  </svg>
);

const ArrowRightIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="5" y1="12" x2="19" y2="12"></line>
    <polyline points="12 5 19 12 12 19"></polyline>
  </svg>
);

// Card Top-Left Badge Icons (enlarged for premium look)
const AndroidBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="9" width="16" height="11" rx="2"></rect>
    <path d="M8 9V6a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v3"></path>
    <line x1="9" y1="2" x2="10" y2="4"></line>
    <line x1="15" y1="2" x2="14" y2="4"></line>
  </svg>
);

const AppleBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="#B88228" stroke="none">
    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M15.97 6.09c.58-.7.98-1.68.87-2.66-.85.03-1.89.57-2.49 1.27-.54.62-.99 1.63-.86 2.59 0 .01 0 .01.01.01.96.07 1.9-.5 2.47-1.21z" />
  </svg>
);

const LaptopBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="5" width="16" height="10" rx="1.5"></rect>
    <path d="M2 19h20"></path>
    <path d="M5 15h14"></path>
  </svg>
);

const DesktopBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="3" width="16" height="12" rx="2"></rect>
    <line x1="8" y1="21" x2="16" y2="21"></line>
    <line x1="12" y1="15" x2="12" y2="21"></line>
  </svg>
);

const DataBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="22" y1="12" x2="2" y2="12"></line>
    <path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>
    <line x1="6" y1="16" x2="6.01" y2="16"></line>
    <line x1="10" y1="16" x2="10.01" y2="16"></line>
  </svg>
);

const ZapBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>
  </svg>
);

const ApplianceBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#B88228" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="4" y="2" width="16" height="20" rx="2"></rect>
    <line x1="4" y1="10" x2="20" y2="10"></line>
    <line x1="9" y1="6" x2="9" y2="6.01"></line>
    <line x1="9" y1="15" x2="9" y2="15.01"></line>
  </svg>
);

// Trust Banner Icons (larger for premium look)
const ScooterIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="6" cy="18" r="2"></circle>
    <circle cx="18" cy="18" r="2"></circle>
    <path d="M8 18h8"></path>
    <path d="M18 16V9l-4-4H8"></path>
    <circle cx="8" cy="10" r="1"></circle>
  </svg>
);

const GenuineBadgeIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="8" r="6"></circle>
    <path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"></path>
  </svg>
);

const TechnicianIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
    <circle cx="12" cy="7" r="4"></circle>
  </svg>
);

const HeadsetIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
    <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>
  </svg>
);

const SameDayIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#C98E32" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="10"></circle>
    <polyline points="12 6 12 12 16 14"></polyline>
  </svg>
);

// --- Premium Circular Display Pedestal ---
const DevicePodium = ({ imageSrc, altText }) => (
  <div className="podium-container">
    <div className="podium-image-frame">
      <img src={imageSrc} alt={altText} className="podium-img" />
    </div>
    {/* <div className="podium-pedestal">
      <div className="podium-pedestal-top"></div>
      <div className="podium-pedestal-base"></div>
      <div className="podium-pedestal-shadow"></div>
    </div> */}
  </div>
);

// Data for Desktop 3-Column Grid Design
const DESKTOP_SERVICES_DATA = [
  {
    id: 'android',
    BadgeIcon: AndroidBadgeIcon,
    imageSrc: '/images/services/android.webp',
    title: 'Premium Android Repair',
    bullets: [
      'Screen Replacement',
      'Battery Replacement',
      'Charging Port Repair',
      'Motherboard Repair',
      'Water Damage Repair',
      'Camera & Speaker Repair',
    ],
    brandsLabel: 'Brands We Support',
    brandsText: 'Samsung, OnePlus, Xiaomi, Realme, Vivo, Oppo, Google Pixel & more',
    link: null,
  },
  {
    id: 'iphone',
    BadgeIcon: AppleBadgeIcon,
    imageSrc: '/images/services/iphone.webp',
    title: 'iPhone Repair',
    bullets: [
      'Display Replacement',
      'Battery Replacement',
      'Face ID Repair',
      'Camera Repair',
      'Water Damage Repair',
      'Logic Board Repair',
      'Back Glass Replacement',
    ],
    brandsLabel: 'Models Supported',
    brandsText: 'iPhone 15, 14, 13, 12, 11, Pro Max, SE & legacy models',
    link: '/iphone-repair',
  },
  {
    id: 'laptop',
    BadgeIcon: LaptopBadgeIcon,
    imageSrc: '/images/services/laptop.webp',
    title: 'Laptop Repair & Upgrade',
    bullets: [
      'Slow Laptop Repair',
      'SSD & RAM Upgrade',
      'Keyboard Replacement',
      'Display Replacement',
      'Battery Replacement',
      'Motherboard & Hinge Fix',
    ],
    brandsLabel: 'Brands We Support',
    brandsText: 'Dell, HP, Lenovo, ASUS, Acer, MSI, Samsung & more',
    link: null,
  },
  {
    id: 'macbook',
    BadgeIcon: AppleBadgeIcon,
    imageSrc: '/images/services/macbook.webp',
    title: 'MacBook Repair',
    bullets: [
      'Screen Replacement',
      'Battery Service',
      'Logic Board Repair',
      'Keyboard Replacement',
      'Liquid Damage Repair',
      'macOS & SSD Upgrade',
    ],
    brandsLabel: 'Chipsets Supported',
    brandsText: 'MacBook Pro & Air M1, M2, M3 Chipsets & Intel MacBooks',
    link: null,
  },
  {
    id: 'pc-building',
    BadgeIcon: DesktopBadgeIcon,
    imageSrc: '/images/services/pc.webp',
    title: 'PC Building & Desktop',
    bullets: [
      'Custom Gaming & Workstation Assembly',
      'Motherboard & CPU Tuning',
      'GPU & Power Supply Upgrade',
      'AIO & Custom Liquid Cooling',
      'Windows OS Installation',
      'Hardware Diagnostics & Clean',
    ],
    brandsLabel: 'Hardware Supported',
    brandsText: 'NVIDIA, AMD, Intel, Corsair, ASUS ROG, MSI, Gigabyte & custom builds',
    link: null,
  },

  {
    id: 'data',
    BadgeIcon: DataBadgeIcon,
    imageSrc: '/images/services/data.webp',
    title: 'Data Recovery Lab',
    bullets: [
      'Hard Drive HDD Recovery',
      'NVMe & SATA SSD Recovery',
      'Deleted File Recovery',
      'Corrupted Data Repair',
      'USB & Memory Card Recovery',
      'Dead Phone & RAID Recovery',
    ],
    brandsLabel: 'Lab Certification',
    brandsText: 'Class-100 Cleanroom Data Recovery Lab with 99% Success Rate',
    link: '/data-recovery',
  },
  {
    id: 'electrician',
    BadgeIcon: ZapBadgeIcon,
    imageSrc: '/images/electrical_contractor.png',
    title: 'Electrician & Contracting',
    bullets: [
      'House Wiring Contracting',
      'Emergency Tripping & MCB Fix',
      'Chandelier & Ambient Lighting',
      'EV Fast Charger Installation',
      'Switchboard & Inverter Repair',
      'Heavy Appliance Power Wiring',
    ],
    brandsLabel: 'Service Scope',
    brandsText: 'Licensed Electricians for Turnkey Residential & Commercial Contracting',
    link: '/electrician',
  },
  {
    id: 'appliance',
    BadgeIcon: ApplianceBadgeIcon,
    imageSrc: '/images/appliance_repair.png',
    title: 'Home Appliance Repair',
    bullets: [
      'AC Servicing, Repair & Gas Refill',
      'Refrigerator & Freezer Repair',
      'Washing Machine Motor & PCB Fix',
      'Microwave & Induction Repair',
      'Geyser & Water Heater Fix',
      'Smart TV & Soundbar Fix',
    ],
    brandsLabel: 'Brands We Repair',
    brandsText: 'LG, Samsung, Whirlpool, Daikin, Voltas, Godrej, Panasonic & all major brands',
    link: null,
  }
];

// Data for Mobile Stacked Card Layout
const MOBILE_SERVICES_DATA = [
  {
    id: 'android',
    popularTag: true,
    BadgeIcon: AndroidBadgeIcon,
    imageSrc: '/images/services/android.webp',
    title: 'Android Repair',
    subtitle: 'Samsung, Google, Xiaomi & more',
    collapsedTags: ['Screen', 'Battery', 'Charging', 'Camera', 'Speaker'],
    moreCount: '+12',
    fullServiceTags: [
      { icon: '📱', name: 'Screen Replacement' },
      { icon: '📷', name: 'Camera Repair' },
      { icon: '🔋', name: 'Battery Replacement' },
      { icon: '⚙️', name: 'Software Issues' },
      { icon: '💧', name: 'Water Damage Repair' },
      { icon: '🎤', name: 'Speaker & Mic' },
      { icon: '🔌', name: 'Charging Port Repair' },
    ],
    moreRepairsText: '+12 More Repairs',
    brandsText: 'Samsung, OnePlus, Xiaomi, Realme, Vivo, Oppo, Motorola, Nothing, Google Pixel & more.',
    link: null,
  },
  {
    id: 'iphone',
    popularTag: false,
    BadgeIcon: AppleBadgeIcon,
    imageSrc: '/images/services/iphone.webp',
    title: 'iPhone Repair',
    subtitle: 'All iPhone Models',
    collapsedTags: ['Display', 'Battery', 'Camera', 'Back Panel', 'Receiver'],
    moreCount: '+10',
    fullServiceTags: [
      { icon: '📱', name: 'Display Replacement' },
      { icon: '🔋', name: 'Battery Replacement' },
      { icon: '🆔', name: 'Face ID Issues' },
      { icon: '📷', name: 'Camera Repair' },
      { icon: '💧', name: 'Water Damage Repair' },
      { icon: '⚡', name: 'Logic Board Repair' },
    ],
    moreRepairsText: '+10 More Repairs',
    brandsText: 'iPhone 15 Pro Max, 15, 14, 13, 12, 11, Pro, SE & all legacy Apple models.',
    link: '/iphone-repair',
  },
  {
    id: 'laptop',
    popularTag: false,
    BadgeIcon: LaptopBadgeIcon,
    imageSrc: '/images/services/laptop.webp',
    title: 'Laptop Repair',
    subtitle: 'All Brands. All Issues.',
    collapsedTags: ['Screen', 'Motherboard', 'RAM', 'Battery', 'Keyboard'],
    moreCount: '+8',
    fullServiceTags: [
      { icon: '💻', name: 'Slow Laptop Repair' },
      { icon: '⚡', name: 'SSD & RAM Upgrade' },
      { icon: '⌨️', name: 'Keyboard Replacement' },
      { icon: '🖥️', name: 'Display Replacement' },
      { icon: '🔋', name: 'Battery Replacement' },
      { icon: '⚙️', name: 'Motherboard Repair' },
    ],
    moreRepairsText: '+8 More Repairs',
    brandsText: 'Dell, HP, Lenovo, ASUS, Acer, MSI, Samsung & more.',
    link: null,
  },
  {
    id: 'macbook',
    popularTag: false,
    BadgeIcon: AppleBadgeIcon,
    imageSrc: '/images/services/macbook.webp',
    title: 'MacBook Repair',
    subtitle: 'Specialized Mac Experts',
    collapsedTags: ['Logic Board', 'Battery', 'Mic', 'Display', 'Liquid Damage'],
    moreCount: '+8',
    fullServiceTags: [
      { icon: '🖥️', name: 'Screen Replacement' },
      { icon: '🔋', name: 'Battery Service' },
      { icon: '⚡', name: 'Logic Board Repair' },
      { icon: '⌨️', name: 'Keyboard Replacement' },
      { icon: '💧', name: 'Liquid Damage Repair' },
      { icon: '🍏', name: 'macOS Issues' },
    ],
    moreRepairsText: '+8 More Repairs',
    brandsText: 'MacBook Pro, MacBook Air, M1, M2, M3 Chipsets & Intel MacBooks.',
    link: null,
  },
  {
    id: 'pc-building',
    popularTag: true,
    BadgeIcon: DesktopBadgeIcon,
    imageSrc: '/images/services/pc.webp',
    title: 'PC Building & Desktop',
    subtitle: 'Build. Assemble. Upgrades. Fix.',
    collapsedTags: ['Custom PC', 'GPU', 'Liquid Cooling', 'RAM', 'Windows'],
    moreCount: '+10',
    fullServiceTags: [
      { icon: '🖥️', name: 'Custom PC Assembly' },
      { icon: '⚙️', name: 'Motherboard Repair' },
      { icon: '🎮', name: 'GPU & PSU Upgrade' },
      { icon: '❄️', name: 'Liquid Cooling Setup' },
      { icon: '🪟', name: 'Windows Installation' },
      { icon: '🛡️', name: 'Virus Removal & Tune' },
    ],
    moreRepairsText: '+10 More Repairs',
    brandsText: 'Custom Gaming Rigs, Dell, HP, Lenovo, ASUS ROG, Alienware & work stations.',
    link: null,
  },
  {
    id: 'electrician',
    popularTag: true,
    BadgeIcon: ZapBadgeIcon,
    imageSrc: '/images/electrical_contractor.png',
    title: 'Electrician & Contracting',
    subtitle: '24/7 House Wiring & Emergency Repairs',
    collapsedTags: ['Wiring', 'MCB Tripping', 'Lighting', 'EV Charger', 'Inverter'],
    moreCount: '+15',
    fullServiceTags: [
      { icon: '⚡', name: 'House Wiring Contracting' },
      { icon: '🚨', name: 'Short Circuit & MCB Fix' },
      { icon: '💡', name: 'Chandelier & Lighting' },
      { icon: '🔌', name: 'EV Fast Charger Setup' },
      { icon: '🔋', name: 'Inverter & Switchboard' },
      { icon: '🏢', name: 'Commercial Electrical' },
    ],
    moreRepairsText: '+15 More Services',
    brandsText: 'Turnkey residential wiring, commercial setup, 24/7 emergency dispatch.',
    link: '/electrician',
  },
  {
    id: 'appliance',
    popularTag: true,
    BadgeIcon: ApplianceBadgeIcon,
    imageSrc: '/images/appliance_repair.png',
    title: 'Home Appliances Repair',
    subtitle: 'AC, Refrigerator, Washing Machine & TV',
    collapsedTags: ['AC Servicing', 'Fridge', 'Washing Machine', 'Microwave', 'Geyser'],
    moreCount: '+12',
    fullServiceTags: [
      { icon: '❄️', name: 'AC Repair & Gas Refill' },
      { icon: '🧊', name: 'Fridge & Freezer Repair' },
      { icon: '🧺', name: 'Washing Machine Service' },
      { icon: '🍲', name: 'Microwave & Induction' },
      { icon: '🔥', name: 'Geyser Repair' },
      { icon: '📺', name: 'Smart TV Service' },
    ],
    moreRepairsText: '+12 More Repairs',
    brandsText: 'LG, Samsung, Whirlpool, Daikin, Voltas, Godrej, Panasonic & all major brands.',
    link: null,
  },
  {
    id: 'data',
    popularTag: false,
    BadgeIcon: DataBadgeIcon,
    imageSrc: '/images/services/data.webp',
    title: 'Data Recovery',
    subtitle: 'We recover what matters.',
    collapsedTags: ['Photos', 'Documents', 'Files', 'Videos', 'External Drives'],
    moreCount: '+6',
    fullServiceTags: [
      { icon: '💾', name: 'Hard Drive Recovery' },
      { icon: '⚡', name: 'SSD Data Recovery' },
      { icon: '📁', name: 'Deleted File Recovery' },
      { icon: '🔒', name: 'Corrupted Data Repair' },
      { icon: '🔌', name: 'USB & Memory Card' },
      { icon: '📱', name: 'Mobile Data Recovery' },
    ],
    moreRepairsText: '+6 More Repairs',
    brandsText: 'Internal HDD, NVMe SSD, SD Cards, Flash Drives, Mobile Devices & NAS Arrays.',
    link: '/data-recovery',
  },
];

const TRUST_ITEMS = [
  { Icon: ScooterIcon, title: 'Doorstep Service', subtitle: 'We come to you' },
  { Icon: SameDayIcon, title: 'Same-Day Repair', subtitle: 'Fast repairs, same day' },
  { Icon: ShieldCheckIcon, title: 'upto 1 Year Warranty', subtitle: 'On all repairs' },
  { Icon: GenuineBadgeIcon, title: 'Genuine Parts', subtitle: '100% original parts' },
  { Icon: TechnicianIcon, title: 'Expert Technicians', subtitle: 'Skilled & verified' },
  { Icon: HeadsetIcon, title: '24/7 Support', subtitle: 'Always here for you' },
];

function Services({ isHome = false }) {
  const [expandedId, setExpandedId] = useState('android');
  const [comingSoonModal, setComingSoonModal] = useState(null);

  const desktopServices = isHome
    ? DESKTOP_SERVICES_DATA.filter((item) => item.id !== 'electrician' && item.id !== 'appliance')
    : DESKTOP_SERVICES_DATA;

  const mobileServices = isHome
    ? MOBILE_SERVICES_DATA.filter((item) => item.id !== 'electrician' && item.id !== 'appliance')
    : MOBILE_SERVICES_DATA;

  const toggleCard = (id) => {
    setExpandedId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="wwr-section" id="services">
      {/* Gold Curved Corner Decorations */}
      <div className="wwr-deco-corner wwr-deco-corner-tl" aria-hidden="true">
        <GoldCurvedCorner />
      </div>
      <div className="wwr-deco-corner wwr-deco-corner-tr" aria-hidden="true">
        <GoldCurvedCorner />
      </div>

      {/* Background Ambient Ornaments */}
      <div className="wwr-bg-dots wwr-bg-dots-left" aria-hidden="true" />
      <div className="wwr-bg-dots wwr-bg-dots-right" aria-hidden="true" />


      <div className="wwr-container">
        {/* Header */}
        <header className="wwr-header">
          <div className="wwr-badge">
            <StarIcon />
            <span>WHAT WE REPAIR</span>
          </div>

          <h2 className="wwr-title">
            <span className="wwr-title-main">Professional Repairs</span>
            <span className="wwr-title-gold">For Every Device</span>
          </h2>

          {/* Gold Diamond Divider Ornament */}
          <div className="wwr-heading-divider" aria-hidden="true">
            <div className="wwr-divider-line"></div>
            <div className="wwr-divider-diamond"></div>
            <div className="wwr-divider-line"></div>
          </div>

          <p className="wwr-subtitle">
            <span className="wwr-subtitle-line">Premium doorstep repair services by expert technicians.</span>
            <br />
            <span className="wwr-subtitle-line">Genuine parts. Trusted by 5000+ customers.</span>
          </p>
        </header>

        {/* ========================================================= */}
        {/* DESKTOP & TABLET VIEW: 3-COLUMN GRID DESIGN               */}
        {/* ========================================================= */}
        <div className="wwr-desktop-view">
          <div className="wwr-grid">
            {desktopServices.map((service) => {
              const { id, BadgeIcon, imageSrc, title, bullets, brandsLabel, brandsText } = service;
              return (
                <div key={id} className="wwr-card">
                  {/* Top-Left Badge Icon */}
                  <div className="wwr-card-badge">
                    <BadgeIcon />
                  </div>

                  {/* Top-Right Chevron Toggle Button */}
                  <button className="wwr-card-chevron" aria-label="Toggle details">
                    <ChevronDownIcon />
                  </button>

                  {/* Card Content Row */}
                  <div className="wwr-card-content">
                    {/* Left Column: Premium 3D Pedestal + Device Image */}
                    <div className="wwr-card-left">
                      <DevicePodium imageSrc={imageSrc} altText={title} />
                    </div>

                    {/* Right Column: Title + Bullets + Brands */}
                    <div className="wwr-card-right">
                      <h3 className="wwr-card-title">{title}</h3>

                      {/* Repair Bullets List */}
                      <ul className="wwr-card-bullets">
                        {bullets.map((item, idx) => (
                          <li key={idx} className="wwr-bullet-item">
                            <GoldCheckIcon />
                            <span>{item}</span>
                          </li>
                        ))}
                      </ul>

                      {/* Optional Brands Section */}
                      {brandsLabel && (
                        <div className="wwr-card-brands">
                          <div className="wwr-brands-label">{brandsLabel}</div>
                          <div className="wwr-brands-text">{brandsText}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Card Footer Link */}
                  <div className="wwr-card-footer">
                    {service.link ? (
                      <Link to={service.link} className="wwr-learn-more">
                        <span>Learn More</span>
                        <ArrowRightIcon />
                      </Link>
                    ) : (
                      <button
                        type="button"
                        className="wwr-learn-more"
                        onClick={() => setComingSoonModal(service)}
                        style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
                      >
                        <span>Learn More</span>
                        <ArrowRightIcon />
                      </button>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* ========================================================= */}
        {/* MOBILE VIEW: STACKED 3D EXPANDABLE CARDS LAYOUT           */}
        {/* ========================================================= */}
        <div className="wwr-mobile-view">
          <div className="wwr-stacked-list">
            {mobileServices.map((service) => {
              const {
                id, popularTag, BadgeIcon, imageSrc, title, subtitle,
                collapsedTags, moreCount, fullServiceTags, moreRepairsText, brandsText,
              } = service;

              const isExpanded = expandedId === id;

              return (
                <div
                  key={id}
                  className={`wwr-3d-card ${isExpanded ? 'wwr-3d-card-expanded' : 'wwr-3d-card-collapsed'}`}
                >
                  {/* Main Interactive Header Bar (Shown when collapsed) */}
                  {!isExpanded && (
                    <div
                      className="wwr-card-header-bar"
                      onClick={() => toggleCard(id)}
                      role="button"
                      tabIndex={0}
                      aria-expanded={false}
                    >
                      {/* Left Badge Icon */}
                      <div className="wwr-icon-badge-box">
                        <BadgeIcon />
                      </div>

                      {/* Thumbnail Device Image */}
                      <div className="wwr-thumb-box">
                        <img src={imageSrc} alt={title} className="wwr-thumb-img" />
                      </div>

                      {/* Center Content Meta */}
                      <div className="wwr-card-meta">
                        <div className="wwr-title-row">
                          {popularTag && <span className="wwr-popular-badge">POPULAR</span>}
                          <h3 className="wwr-card-heading">{title}</h3>
                        </div>

                        <p className="wwr-card-subheading">{subtitle}</p>

                        <div className="wwr-collapsed-meta">
                          <div className="wwr-tags-row">
                            {collapsedTags.map((tag, idx) => (
                              <span key={idx} className="wwr-tag-pill">{tag}</span>
                            ))}
                            <span className="wwr-tag-pill wwr-tag-pill-more">{moreCount}</span>
                          </div>

                          <div className="wwr-guarantee-line">
                            <span className="wwr-guarantee-item">
                              <ShieldCheckIcon /> Genuine Parts
                            </span>
                            <span className="wwr-dot-separator">•</span>
                            <span className="wwr-guarantee-item">upto 1 Year Warranty</span>
                          </div>
                        </div>
                      </div>

                      {/* Right Circular Action Button */}
                      <button
                        className="wwr-circular-action-btn"
                        aria-label="Expand card"
                      >
                        <PlusIcon />
                      </button>
                    </div>
                  )}

                  {/* Expanded Body Content */}
                  {isExpanded && (
                    <div className="wwr-expanded-body">
                      {/* Expanded Top Header Bar with Close Button */}
                      <div
                        className="wwr-expanded-header-bar"
                        onClick={() => toggleCard(id)}
                        role="button"
                        tabIndex={0}
                        aria-expanded={true}
                      >
                        <button
                          className="wwr-circular-action-btn"
                          aria-label="Collapse card"
                        >
                          <ChevronUpIcon />
                        </button>
                      </div>

                      {/* Device Presentation */}
                      <div className="wwr-stage-column">
                        <div className="podium-3d-stage">
                          <div className="podium-image-frame">
                            <img src={imageSrc} alt={title} className="podium-device-img" />
                          </div>
                        </div>
                      </div>

                      {/* Heading & Subheading below stage */}
                      <div className="wwr-expanded-title-box">
                        <h3 className="wwr-card-heading">{title}</h3>
                        <p className="wwr-card-subheading">{subtitle}</p>
                      </div>

                      {/* Full Services Grid & CTA */}
                      <div className="wwr-details-column">
                        <div className="wwr-full-pills-grid">
                          {fullServiceTags.map((tagItem, idx) => (
                            <div key={idx} className="wwr-service-pill">
                              <span className="wwr-pill-emoji">{tagItem.icon}</span>
                              <span>{tagItem.name}</span>
                            </div>
                          ))}
                          <div className="wwr-service-pill wwr-more-repairs-btn">
                            <span>{moreRepairsText}</span>
                          </div>
                        </div>

                        <div className="wwr-brands-container">
                          <div className="wwr-brands-header">
                            <GoldShieldIcon />
                            <span>All Major Brands Supported</span>
                          </div>
                          <p className="wwr-brands-desc">{brandsText}</p>
                        </div>

                        {service.link ? (
                          <Link to={service.link} className="wwr-full-dark-cta">
                            <span>Learn More</span>
                            <ArrowRightIcon />
                          </Link>
                        ) : (
                          <button
                            type="button"
                            className="wwr-full-dark-cta"
                            onClick={() => setComingSoonModal(service)}
                            style={{ border: 'none', cursor: 'pointer' }}
                          >
                            <span>Learn More</span>
                            <ArrowRightIcon />
                          </button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* Bottom Trust Banner */}
        <div className="wwr-trust-banner">
          {TRUST_ITEMS.map((item, index) => {
            const { Icon, title, subtitle } = item;
            return (
              <div key={index} className="wwr-trust-item">
                <div className="wwr-trust-icon-box">
                  <Icon />
                </div>
                <div className="wwr-trust-info">
                  <h4 className="wwr-trust-title">{title}</h4>
                  <p className="wwr-trust-desc">{subtitle}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Coming Soon Modal */}
      {comingSoonModal && (
        <div className="cs-modal-overlay" onClick={() => setComingSoonModal(null)}>
          <div className="cs-modal-content" onClick={(e) => e.stopPropagation()}>
            <button
              className="cs-modal-close"
              onClick={() => setComingSoonModal(null)}
              aria-label="Close modal"
            >
              ✕
            </button>

            <div className="cs-modal-badge">
              <SparklesIcon />
              <span>COMING SOON</span>
            </div>

            <h3 className="cs-modal-title">{comingSoonModal.title}</h3>

            <p className="cs-modal-desc">
              We are currently building a dedicated showcase page for <strong>{comingSoonModal.title}</strong>.
              In the meantime, our expert technicians are fully available to assist with your repair right now at your doorstep!
            </p>

            <div className="cs-modal-actions">
              <a
                href="/#booking"
                className="cs-modal-btn-primary"
                onClick={() => {
                  setComingSoonModal(null);
                  const bookingEl = document.getElementById('booking');
                  if (bookingEl) {
                    bookingEl.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
              >
                Book Repair Now
              </a>
              <button
                className="cs-modal-btn-secondary"
                onClick={() => setComingSoonModal(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Services;
